import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
// import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
// import PropertyDetails from "./features/properties/PropertyDetails";
import PropertyDetails from "./features/properties/PropertyDetailsPG";
import Error from "./pages/Error";
// import HowToRent from "./pages/HowToRent";
// import ContactUs from "./pages/ContactUs";
// import Nft from "./features/nfts/Nft";
// import Register from "./features/auth/Register";
import Login from "./features/auth/Login";
import Username from "./features/auth/Username";
import { GoogleOAuthProvider } from "@react-oauth/google";
// import MyAssets from "./features/assets/MyAssets";

import { store } from "./app/store";
import { Provider } from "react-redux";
import { disableReactDevTools } from "@fvilers/disable-react-devtools";

// import UsersList from "./features/users/UsersList";
// import NewUser from "./features/users/NewUser";
// import EditUser from "./features/users/EditUser";

import PropertiesList from "./features/properties/PropertiesList";
import MyPropertiesList from "./features/properties/MyPropertiesList";
// import EditProperty from "./features/properties/pages/EditProperty";
import EditProperty from "./features/properties/pages/EditPropertyPG";
import Prefetch from "./features/auth/prefetch";
import PersistLogin from "./features/auth/PersistLogin";
import RequireAuth from "./features/auth/RequireAuth";
import { ROLES } from "./config/roles";
// import MyPropertyDetails from "./features/properties/MyPropertyDetails";
import MyPropertyDetails from "./features/properties/MyPropertyDetailsPG";
// import AddProperty from "./features/properties/pages/AddProperty";
import AddProperty from "./features/properties/pages/AddPropertyPG";
import AddUnits from "./features/units/pages/AddUnits";
import PropertySearch from "./pages/PropertySearch";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <Error />,
    children: [
      {
        path: "/",
        element: <PropertiesList />,
      },
      {
        path: "/search",
        element: <PropertySearch />,
      },
      // {
      //   path: "/how-to-rent",
      //   element: <HowToRent />,
      // },
      // {
      //   path: "/nft",
      //   element: <Nft />,
      // },
      // {
      //   path: "/property",
      //   element: <PropertiesList />,
      // },
      // {
      //   path: "/contact-us",
      //   element: <ContactUs />,
      // },
      {
        path: "/login",
        element: <Login />,
      },
      // {
      //   path: "/register",
      //   element: <Register />,
      // },
      {
        path: "/username",
        element: <Username />,
      },
      {
        path: "property/:id",
        element: <PropertyDetails />,
      },
      // Protected Routes
      {
        element: <PersistLogin />,
        children: [
          {
            element: <RequireAuth allowedRoles={[...Object.values(ROLES)]} />,
            children: [
              {
                element: <Prefetch />,
                children: [
                  // {
                  //   path: "/my-assets",
                  //   element: <MyAssets />,
                  // },
                  {
                    path: "/my-properties",
                    element: <MyPropertiesList />,
                  },
                  {
                    path: "/my-properties/:id",
                    element: <MyPropertyDetails />,
                  },
                  {
                    path: "/my-properties/new",
                    element: <AddProperty />,
                  },
                  {
                    path: "/my-properties/edit/:id",
                    element: <EditProperty />,
                  },
                  {
                    path: "/my-units/new",
                    element: <AddUnits />,
                  },
                  // {
                  //   element: (
                  //     <RequireAuth
                  //       allowedRoles={[ROLES.Owner, ROLES.Admin, ROLES.Manager]}
                  //     />
                  //   ),
                  //   children: [
                  //     {
                  //       path: "/users",
                  //       element: <UsersList />,
                  //     },
                  //     {
                  //       path: "users/:id",
                  //       element: <EditUser />,
                  //     },
                  //     {
                  //       path: "users/new",
                  //       element: <NewUser />,
                  //     },
                  //   ],
                  // },
                ],
              },
            ],
          },
        ],
      },
      // End Protected Routes
    ],
  },
]);

if (process.env.NODE_ENV === "production") disableReactDevTools();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
        <RouterProvider router={router} />
      </GoogleOAuthProvider>
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
